import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppStateGateway } from '@cigna/cigna-for-brokers/shared/gateways';
import { Observable, BehaviorSubject, Subject, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContactUsDialogService {
  getAppointedClickedSubject = new Subject<boolean>();

  publishGetAppointedClick() {
    this.getAppointedClickedSubject.next(true);
  }
}
